<template>
  <section class="content">
    <div class="row center-block">
      <!--      <h2>Data tables</h2>-->
      <div class="col-md-12 row-rm-padding">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title pull-right">
              <button type="button" @click="newModal = true" class="btn primary-btn-my clear-new-modal">Add</button>
            </h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-6">
                  <div id="example1_length" class="dataTables_length">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table aria-describedby="example1_info" role="grid" id="tableData"
                         class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th aria-label="Rendering engine: activate to sort column descending" aria-sort="ascending"
                          style="width: 10%" colspan="1" rowspan="1" aria-controls="example1" tabindex="0"
                          class="sorting_asc">Date
                      </th>
                      <th aria-label="Browser: activate to sort column ascending" style="width: 50%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Product Name
                      </th>
                       <th aria-label="Browser: activate to sort column ascending" style="width: 35%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Product category
                      </th>
                      <th style="width: 5%;" colspan="1" rowspan="1" tabindex="0">Actions</th>
                    </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
<!-- ================== New products model ================== -->
     <md-dialog :md-active.sync="newModal" class="model_show_products">
      <md-dialog-title class="model-title">Add new Product
        <a style="float: right;cursor: pointer;" class="md-primary" @click="newModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
       <form class="from_padding_product">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClassNewForm('name')">
                <label class="lable-fileds">Product Name</label>
                <md-input name="name" id="name" v-model="newForm.name" />
                <span class="md-error" v-if="!$v.newForm.name.required">The Product Name is required</span>
                <span class="md-error" v-if="$v.newForm.name.required && this.newFormBackendValidation.name.isError">{{this.newFormBackendValidation.name.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClassNewForm('category_catalog_id')">
                <label class="lable-fileds">Product Category</label>
                <md-select v-model="newForm.category_catalog_id" name="category_catalog_id" id="category_catalog_id">
                  <md-option v-for="item in categoryList" v-bind:key="item.id" :value="item.id" >
                    {{item.name}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.newForm.category_catalog_id.required">The Product Category is required</span>
                <span class="md-error" v-if="$v.newForm.category_catalog_id.required && this.newFormBackendValidation.category_catalog_id.isError">{{this.newFormBackendValidation.category_catalog_id.errorMsg}}</span>
              </md-field>
              <div>
                <label class="lable-fileds">Product description</label>
                <ckeditor v-model="descriptionArea"></ckeditor>
              </div>
              <div>
                <uploader
                  title='Upload Images'
                  v-model="fileList"
                  limit=20
                  :autoUpload="false"
                  @on-change="onChange"
                  @on-delete="onDelete"
                ></uploader>
              </div>
              <md-field :class="getValidationClassNewForm('selectedPrimary')">
                <label class="lable-fileds">Select Primary Image</label>
                <md-select v-model="newForm.selectedPrimary" name="selectedPrimary" id="selectedPrimary">
                  <md-option v-for="item in Imagelenght" v-bind:key="item.id" :value="item" >
                    Image {{item+1}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.newForm.selectedPrimary.required">The selectedPrimary is required</span>
                <span class="md-error" v-if="$v.newForm.selectedPrimary.required && this.newFormBackendValidation.selectedPrimary.isError">{{this.newFormBackendValidation.selectedPrimary.errorMsg}}</span>
              </md-field>
              <div>
                <md-field :class="getValidationClassNewForm('attributes')">
                  <label v-if="tableHeadersSelected.length != 0" class="multiLable">Select the table headers</label>
                  <multiselect v-model="tableHeadersSelected" tag-placeholder="Select the table headers" placeholder="Select the table headers" label="name" @input="changeTable()" track-by="id" :options="headerList" :multiple="true" :taggable="true"></multiselect>
                  <span class="md-error" v-if="!$v.newForm.attributes.required">The table headers is required</span>
                  <span class="md-error" v-if="$v.newForm.attributes.required && this.newFormBackendValidation.attributes.isError">{{this.newFormBackendValidation.attributes.errorMsg}}</span>
                </md-field>
              </div>
              <div v-if="columns.length > 0">
                 <button type="button" @click="addRowModal = true" class="btn primary-btn-my add_row">Add</button>
                <table class="table">
                <thead class="thead_style">
                  <tr>
                      <th v-for="(column, index) in columns" :key="index"> {{column.name}}</th>
                      <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                      <td v-for="(column, indexColumn) in columns" :key="indexColumn">{{item[column.slug]}}</td>
                      <td><button type="button" @click="editRow(index)" class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                      &nbsp;<button type="button"  @click="deleteRow(index)" class="btn btn-danger btn-sm btn-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                      </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div>
         <div class="custom-modal-footer-spaces"></div>

         <div class="custom-modal-footer-container">
           <button type="button" @click="validateSubmission()" class="btn primary-btn-my custom-modal-footer-items">
             Add Product
           </button>&nbsp;&nbsp;&nbsp;
           <button type="button" @click="validateSubmission('stay')" class="btn primary-btn-my custom-modal-footer-items">
             Add & Create Another One
           </button>&nbsp;&nbsp;&nbsp;
           &nbsp;&nbsp;&nbsp;
           <button type="button" @click="clearNewForm" class="btn default_btn-my custom-modal-footer-items">
             Clear Form
           </button>
           <sync-loader class="custom-modal-footer-items" :loading="newModalLoading" :color="newModalColor" :size="newModalSize" :width="newModalWidth" :margin="newModalMargin"></sync-loader>
         </div>

       </form>
    </md-dialog>



     <!-- ================== Edit Products model ================== -->
    <md-dialog :md-active.sync="editModal" class="model_show_products">
      <md-dialog-title class="model-title">Edit Product
        <a style="float: right;cursor: pointer;" class="md-primary" @click="editModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from_padding_product">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClassEditForm('name')">
                <label class="lable-fileds">Product Name</label>
                <md-input name="name" id="name" v-model="editForm.name" />
                <span class="md-error" v-if="!$v.editForm.name.required">The Product Name is required</span>
                <span class="md-error" v-if="$v.editForm.name.required && this.editFormBackendValidation.name.isError">{{this.editFormBackendValidation.name.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClassEditForm('category_catalog_id')">
                <label class="lable-fileds">Product Category</label>
                <md-select v-model="editForm.category_catalog_id" name="category_catalog_id" id="category_catalog_id">
                  <md-option v-for="item in categoryList" v-bind:key="item.id" :value="item.id" >
                    {{item.name}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.editForm.category_catalog_id.required">The Product Category is required</span>
                <span class="md-error" v-if="$v.editForm.category_catalog_id.required && this.editFormBackendValidation.category_catalog_id.isError">{{this.editFormBackendValidation.category_catalog_id.errorMsg}}</span>
              </md-field>
              <div>
                <label class="lable-fileds">Product description</label>
                <ckeditor v-model="descriptionArea"></ckeditor>
              </div>
              <br>
              <div>
                <p>Uploaded Images</p>
                <ul class="up_image_list">
                  <li v-for="item in uploadedImageList" v-bind:key="item.id">
                    <div class="dd_img">
                      <img v-bind:src='item.thumbnail '>
                      <div class="deleteBtn" @click="deleteImage(item)"><i class="fa fa-trash-o" aria-hidden="true"></i></div>
                    </div>
                  </li>
                </ul>
              </div>
              <div>
                <uploader
                  title='Upload Images'
                  v-model="fileList"
                  limit=20
                  :autoUpload="false"
                  @on-change="onChange"
                  @on-delete="onDelete"
                ></uploader>
              </div>
              <md-field :class="getValidationClassEditForm('selectedPrimary')">
                <label class="lable-fileds">Select Primary Image</label>
                <md-select v-model="editForm.selectedPrimary" name="selectedPrimary" id="selectedPrimary">
                  <md-option v-for="item in Imagelenght" v-bind:key="item.id" :value="item" >
                    Image {{item+1}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.editForm.selectedPrimary.required">The selectedPrimary is required</span>
                <span class="md-error" v-if="$v.editForm.selectedPrimary.required && this.editFormBackendValidation.selectedPrimary.isError">{{this.editFormBackendValidation.selectedPrimary.errorMsg}}</span>
              </md-field>
              <div>
                <md-field :class="getValidationClassEditForm('attributes')">
                  <label v-if="tableHeadersSelected.length != 0" class="multiLable">Select the table headers</label>
                  <multiselect v-model="tableHeadersSelected" tag-placeholder="Select the table headers" placeholder="Select the table headers" label="name" @input="changeTable()" track-by="id" :options="headerList" :multiple="true" :taggable="true"></multiselect>
                  <span class="md-error" v-if="!$v.editForm.attributes.required">The table headers is required</span>
                  <span class="md-error" v-if="$v.editForm.attributes.required && this.editFormBackendValidation.attributes.isError">{{this.editFormBackendValidation.attributes.errorMsg}}</span>
                </md-field>
              </div>
              <div v-if="columns.length > 0">
                 <button type="button" @click="addRowModal = true" class="btn primary-btn-my add_row">Add</button>
                <table class="table">
                <thead class="thead_style">
                  <tr>
                      <th v-for="(column, index) in columns" :key="index"> {{column.name}}</th>
                      <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index" v-if="item.status === '1'">
                      <td v-for="(column, indexColumn) in columns" :key="indexColumn" >{{item[column.slug]}}</td>
                      <td><button type="button" @click="editRow(index)" class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                      &nbsp;<button type="button"  @click="deleteRow(index)" class="btn btn-danger btn-sm btn-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                      </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div>

          <div class="custom-modal-footer-spaces"></div>

          <div class="custom-modal-footer-container">
            <button type="button" @click="validateSubmission" class="btn primary-btn-my custom-modal-footer-items">
              Update Product
            </button>
            &nbsp;&nbsp;&nbsp;
            <sync-loader class="custom-modal-footer-items" :loading="editModalLoading" :color="editModalColor" :size="editModalSize" :width="editModalWidth" :margin="editModalMargin"></sync-loader>
          </div>

        </form>
    </md-dialog>

     <!-- ================== Add new Row model ================== -->
    <md-dialog :md-active.sync="addRowModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Add new Row
        <a style="float: right;cursor: pointer;" class="md-primary" @click="addRowModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
         <form class="from-padding modal-width-100">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field  v-for="item in tableHeadersSelected" v-bind:key="item.id" :value="item.id">
                <label class="lable-fileds">{{item.name}}</label>
                <md-input name="no" id="no" autocomplete="no" v-model="rowItems[item.slug]" />
              </md-field>
              <md-field >
                 <label class="lable-fileds">Type</label>
                <md-select v-model="rowItems.type_id" name="type_id" id="type_id">
                   <md-option v-for="item in tableTypeList" v-bind:key="item.id" :value="item.id" >
                    {{item.name}}
                  </md-option>
                </md-select>
              </md-field>
              <md-field >
                <label class="lable-fileds">Colors</label>
                <md-select v-model="rowItems.colors" name="colors" id="colors" multiple>
                  <md-option v-for="item in colourList" v-bind:key="item.id" :value="item.id" >
                    {{item.name}}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>

           <div class="custom-modal-footer-spaces"></div>

           <div class="custom-modal-footer-container">
             <button type="button" @click="addNewRow" class="btn primary-btn-my custom-modal-footer-items">
               Add Row
             </button>
           </div>

        </form>
    </md-dialog>

     <!-- ================== Update new Row model ================== -->
    <md-dialog :md-active.sync="updateRowModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Update Row
        <a style="float: right;cursor: pointer;" class="md-primary" @click="updateRowModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
         <form class="from-padding modal-width-100">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field  v-for="item in tableHeadersSelected" v-bind:key="item.id" :value="item.id">
                <label class="lable-fileds">{{item.name}}</label>
                <md-input name="no" id="no" autocomplete="no" v-model="editRowItems[item.slug]" />
              </md-field>
              <md-field >
                 <label class="lable-fileds">Type</label>
                <md-select v-model="editRowItems.type_id" name="type_id" id="type_id">
                   <md-option v-for="item in tableTypeList" v-bind:key="item.id" :value="item.id" >
                    {{item.name}}
                  </md-option>
                </md-select>
              </md-field>
              <md-field >
                <label class="lable-fileds">Colors</label>
                <md-select v-model="editRowItems.colors" name="colors" id="colors" multiple>
                  <md-option v-for="item in colourList" v-bind:key="item.id" :value="item.id" >
                    {{item.name}}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
           <div class="custom-modal-footer-spaces"></div>

           <div class="custom-modal-footer-container">
             <button type="button" @click="updateRowData" class="btn primary-btn-my custom-modal-footer-items">
               Update Row
             </button>
           </div>

         </form>
    </md-dialog>

  </section>

</template>

<script>
  import AWS from 'aws-sdk'

  AWS.config.region = 'ap-southeast-1' // 1. Enter your region

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'ap-southeast-1:d3a76794-ef80-4000-a846-afb95dc782f3' // 2. Enter your identity pool
  })

  AWS.config.credentials.get(function(err) {
    if (err) alert(err)
  })

  var bucketName = 'smartapprcp' // Enter your bucket name
  var bucket = new AWS.S3({
    params: {
      Bucket: bucketName
    }
  })
  import $ from 'jquery'
  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')
  var SyncLoader = require('vue-spinner/src/SyncLoader')

  // vue validations
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import config from '../../../config'
  import Vue from 'vue'
  var moment = require('moment')
  import api from '../../../api'
  import Uploader from 'vux-uploader-component'

export default {
    name: 'ProductView',
    components: {
      'SyncLoader': SyncLoader,
      Uploader
    },
    mixins: [validationMixin],
    data() {
      return {
        createTable: false,
        items: [],
        columns: [],
        datatable: null,
        headerList: [],
        tableHeadersSelected: [],
        descriptionArea: '',
        fileList: [],
        Imagelenght: [],
        tableTypeList: [],
        colourList: [],
        categoryList: [],
        uploadedImageList: [],
        editIndex: '',
        editItem: '',
        rowItems: {
          no: null,
          description: null,
          metric_description: null,
          metric_capacity: null,
          load_capacity: null,
          pack: null,
          type_id: null,
          colors: [],
          metric_dimension: null,
          dimension: null,
          capacity: null,
          metric_weight: null,
          cigarette_count: null,
          deck_size: null,
          castor_type: null,
          overall_dimension: null,
          size: null,
          top: null,
          cross_weight: null,
          quantity_case_pack_size: null,
          metric_ship: null,
          head_band_size: null,
          case_weight: null
        },
        editRowItems: {
          no: null,
          id: null,
          description: null,
          metric_description: null,
          metric_capacity: null,
          load_capacity: null,
          pack: null,
          type_id: null,
          colors: [],
          metric_dimension: null,
          dimension: null,
          capacity: null,
          metric_weight: null,
          cigarette_count: null,
          deck_size: null,
          castor_type: null,
          overall_dimension: null,
          size: null,
          top: null,
          cross_weight: null,
          quantity_case_pack_size: null,
          metric_ship: null,
          head_band_size: null,
          case_weight: null
        },
        newForm: {
          name: null,
          description: null,
          images: [],
          selectedPrimary: null,
          thumbnail_medium: null,
          attributes: [],
          category_catalog_id: null,
          device_type: 'b'
        },
        editForm: {
          name: null,
          description: null,
          images: [],
          selectedPrimary: null,
          thumbnail_medium: null,
          attributes: [],
          category_catalog_id: null,
          device_type: 'b'
        },
        active: false,
        editModal: false,
        newModal: false,
        addRowModal: false,
        updateRowModal: false,
        editModalColor: '#FECD2F',
        editModalSize: '10px',
        editModalLoading: false,
        editModalHeight: '35px',
        editModalWidth: '5px',
        editModalMargin: '2px',
        editModalRadius: '2px',
        newModalColor: '#FECD2F',
        newModalSize: '10px',
        newModalLoading: false,
        newModalHeight: '35px',
        newModalWidth: '5px',
        newModalMargin: '2px',
        newModalRadius: '2px',
        newFormBackendValidation: {
          name: {
            isError: false,
            errorMsg: ''
          },
          attributes: {
            isError: false,
            errorMsg: ''
          },
          category_catalog_id: {
            isError: false,
            errorMsg: ''
          },
          selectedPrimary: {
            isError: false,
            errorMsg: ''
          }
        },
        editFormBackendValidation: {
          name: {
            isError: false,
            errorMsg: ''
          },
          attributes: {
            isError: false,
            errorMsg: ''
          },
          category_catalog_id: {
            isError: false,
            errorMsg: ''
          },
          selectedPrimary: {
            isError: false,
            errorMsg: ''
          }
        }
      }
    },
    mounted() {
      var ref = this
      $('h3').on('click', 'button.clear-new-modal', function () {
        ref.clearNewForm()
      })
      // clear new modal
      this.$nextTick(() => {
        this.getHeaderList()
        this.getCategoryList()
        this.getTableTypeList()
        this.getColourList()
        this.initDatatables()
        this.initJqueryMethods()
      })
    },

    validations: {
      newForm: {
        name: {
          required
        },
        attributes: {
          required
        },
        category_catalog_id: {
          required
        },
        selectedPrimary: {
          required
        }
      },
      editForm: {
        name: {
          required
        },
        attributes: {
          required
        },
        category_catalog_id: {
          required
        },
        selectedPrimary: {
          required
        }
      }
    },

    methods: {
      onChange(fileItem, fileList) {
        this.Imagelenght = []
        var tot = this.fileList.length + this.uploadedImageList.length
        for (let x = 0; x < tot; x++) {
          this.Imagelenght.push(x)
        }
        // for (let x = this.fileList.length; x < this.uploadedImageList.length; x++) {
        //   this.Imagelenght.push(x)
        // }
      },

      onDelete(deleteItem, cb) {
        cb && cb()
      },

      initDatatables() {
        this.dataTable = $('#tableData')
          .on('xhr.dt', function (e, settings, json, xhr) {
            json.recordsTotal = json.data.original.recordsTotal
            json.draw = json.data.original.draw
            json.recordsFiltered = json.data.original.recordsFiltered
          })
          .DataTable({
            serverSide: true,
            processing: true,
            responsive: true,
            paging: true,
            lengthChange: true,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            search: {
              'caseInsensitive': false
            },

            order: [[0, 'desc']],
            ajax: {
              url: config.serverURI + '/admin/productcatalog/datatable',
              type: 'get',
              contentType: 'application/json; charset=UTF-8',
              dataSrc: 'data.original.data',
              headers: {
                'Authorization': 'Bearer ' + Vue.auth.getToken()
              }
            },
            columnDefs: [
              {
                'orderable': true,
                'targets': [0],
                'responsivePriority': 0,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + moment(full.created_at).format('MM/DD/YYYY') + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [1],
                'responsivePriority': 1,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.name + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [2],
                'responsivePriority': 2,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.category.name + '</span>'
                }
              },
              {
                'orderable': false,
                'targets': [3],
                'responsivePriority': 3,
                'searchable': false,
                'className': 'details-control',
                'render': function (data, type, full, meta) {
                  return '<button type="button" data-id= ' + full.id + ' class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-pencil" aria-hidden="true"></i>' +
                    '</button>&nbsp;<button data-id= ' + full.id + ' type="button" class="btn btn-danger btn-sm btn-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></button>'
                }
              }
            ]
          })
      },

      deleteImage(index) {
        for (let x = 0; x < this.uploadedImageList.length; x++) {
          if (this.uploadedImageList[x].id === index.id) {
            this.uploadedImageList.splice(x, 1)
          }
          for (let x = 0; x < this.editForm.images.length; x++) {
            if (this.editForm.images[x] === index.thumbnail) {
              this.editForm.images.splice(x, 1)
            }
          }
        }
        this.Imagelenght = []
        var tot = this.fileList.length + this.uploadedImageList.length
        for (let x = 0; x < tot; x++) {
          this.Imagelenght.push(x)
        }
      },

      initJqueryMethods() {
        var ref = this
        // edit modal open
        $('#tableData tbody').on('click', 'td.details-control button.btn-modal-edit', function () {
          var id = $(this).attr('data-id')
          ref.showEditModal(id)
        })
        // delete record
        $('#tableData tbody').on('click', 'td.details-control button.btn-delete', function () {
          var id = $(this).attr('data-id')
          ref.deleteNewRecord(id)
        })
      },

      clearNewForm() {
        this.$v.$reset()
        this.newForm.name = null
        this.newForm.description = null
        this.newForm.images = []
        this.newForm.selectedPrimary = null
        this.newForm.thumbnail_medium = null
        this.newForm.attributes = []
        this.newForm.category_catalog_id = null
        this.editForm.name = null
        this.editForm.description = null
        this.editForm.images = []
        this.editForm.selectedPrimary = null
        this.editForm.thumbnail_medium = null
        this.editForm.attributes = []
        this.editForm.category_catalog_id = null
        this.items = []
        this.columns = []
        this.descriptionArea = ''
        this.tableHeadersSelected = []
        this.fileList = []
        this.Imagelenght = []
        this.uploadedImageList = []
      },

      clearTableValueForm() {
        this.rowItems.no = ''
        this.rowItems.description = ''
        this.rowItems.metric_description = ''
        this.rowItems.metric_capacity = ''
        this.rowItems.load_capacity = ''
        this.rowItems.pack = ''
        this.rowItems.type_id = ''
        this.rowItems.colors = []
        this.rowItems.metric_dimension = ''
        this.rowItems.dimension = ''
        this.rowItems.capacity = ''
        this.rowItems.metric_weight = ''
        this.rowItems.cigarette_count = ''
        this.rowItems.deck_size = ''
        this.rowItems.castor_type = ''
        this.rowItems.overall_dimension = ''
        this.rowItems.size = ''
        this.rowItems.top = ''
        this.rowItems.cross_weight = ''
        this.rowItems.quantity_case_pack_size = ''
        this.rowItems.metric_ship = ''
        this.rowItems.head_band_size = ''
        this.rowItems.case_weight = ''
      },

      changeTable() {
        this.columns = []
        this.newForm.attributes = []
        this.editForm.attributes = []
        for (let x = 0; x < this.tableHeadersSelected.length; x++) {
          var colomObject = {}
          colomObject.name = this.tableHeadersSelected[x].name
          colomObject.slug = this.tableHeadersSelected[x].slug
          this.columns.push(colomObject)
          this.newForm.attributes.push(this.tableHeadersSelected[x].id)
          this.editForm.attributes.push(this.tableHeadersSelected[x].id)
        }
        var obj1 = {}
        obj1.name = 'Colour'
        obj1.slug = 'colour'
        this.columns.push(obj1)

        var obj2 = {}
        obj2.name = 'Type'
        obj2.slug = 'type'
        this.columns.push(obj2)
      },

      addNewRow() {
        var newRowData = {}
        var colorArr = []
        newRowData.no = this.rowItems.no
        newRowData.description = this.rowItems.description
        newRowData.metric_description = this.rowItems.metric_description
        newRowData.metric_capacity = this.rowItems.metric_capacity
        newRowData.load_capacity = this.rowItems.load_capacity
        newRowData.pack = this.rowItems.pack
        newRowData.type_id = this.rowItems.type_id
        newRowData.colors = this.rowItems.colors
        newRowData.status = '1'
        for (let x = 0; x < this.tableTypeList.length; x++) {
          if (this.rowItems.type_id === this.tableTypeList[x].id) {
            newRowData.type = this.tableTypeList[x].name
          }
        }
        for (let x = 0; x < this.colourList.length; x++) {
          for (let y = 0; y < newRowData.colors.length; y++) {
            if (newRowData.colors[y] === this.colourList[x].id) {
              colorArr.push(this.colourList[x].name)
            }
          }
        }
        newRowData.colour = colorArr.toString()
        newRowData.metric_dimension = this.rowItems.metric_dimension
        newRowData.dimension = this.rowItems.dimension
        newRowData.capacity = this.rowItems.capacity
        newRowData.metric_weight = this.rowItems.metric_weight
        newRowData.cigarette_count = this.rowItems.cigarette_count
        newRowData.deck_size = this.rowItems.deck_size
        newRowData.castor_type = this.rowItems.castor_type
        newRowData.overall_dimension = this.rowItems.overall_dimension
        newRowData.size = this.rowItems.size
        newRowData.top = this.rowItems.top
        newRowData.cross_weight = this.rowItems.cross_weight
        newRowData.quantity_case_pack_size = this.rowItems.quantity_case_pack_size
        newRowData.metric_ship = this.rowItems.metric_ship
        newRowData.head_band_size = this.rowItems.head_band_size
        newRowData.case_weight = this.rowItems.case_weight
        this.items.push(newRowData)
        this.addRowModal = false
        this.clearTableValueForm()
      },

      loadTableRow(dataSet) {
        dataSet.forEach(data => {
          console.log(data)
          var newRowData = {}
          var colorArr = []
          newRowData.no = data.no
          newRowData.description = data.description
          newRowData.metric_description = data.metric_description
          newRowData.metric_capacity = data.metric_capacity
          newRowData.load_capacity = data.load_capacity
          newRowData.pack = data.pack
          newRowData.type_id = data.type.id
          newRowData.id = data.id
          newRowData.status = '1'
          var col = data.colors
          newRowData.colors = []
          if (col.length > 0) {
            for (let x = 0; x < col.length; x++) {
              newRowData.colors.push(col[x].id)
            }
          }
          for (let x = 0; x < this.tableTypeList.length; x++) {
            if (newRowData.type_id === this.tableTypeList[x].id) {
              newRowData.type = this.tableTypeList[x].name
            }
          }
          if (newRowData.colors.length > 0) {
            for (let x = 0; x < this.colourList.length; x++) {
              for (let y = 0; y < newRowData.colors.length; y++) {
                if (newRowData.colors[y] === this.colourList[x].id) {
                  colorArr.push(this.colourList[x].name)
                }
              }
            }
          }
          newRowData.colour = colorArr.toString()
          newRowData.metric_dimension = data.metric_dimension
          newRowData.dimension = data.dimension
          newRowData.capacity = data.capacity
          newRowData.metric_weight = data.metric_weight
          newRowData.cigarette_count = data.cigarette_count
          newRowData.deck_size = data.deck_size
          newRowData.castor_type = data.castor_type
          newRowData.overall_dimension = data.overall_dimension
          newRowData.size = data.size
          newRowData.top = data.top
          newRowData.cross_weight = data.cross_weight
          newRowData.quantity_case_pack_size = data.quantity_case_pack_size
          newRowData.metric_ship = data.metric_ship
          newRowData.head_band_size = data.head_band_size
          newRowData.case_weight = data.case_weight
          this.items.push(newRowData)
        })
      },

      editRow(index) {
        this.editRowItems.no = this.items[index].no
        this.editRowItems.id = this.items[index].id
        this.editRowItems.description = this.items[index].description
        this.editRowItems.metric_description = this.items[index].metric_description
        this.editRowItems.metric_capacity = this.items[index].metric_capacity
        this.editRowItems.load_capacity = this.items[index].load_capacity
        this.editRowItems.pack = this.items[index].pack
        this.editRowItems.type_id = this.items[index].type_id
        this.editRowItems.colors = this.items[index].colors
        this.editRowItems.metric_dimension = this.items[index].metric_dimension
        this.editRowItems.dimension = this.items[index].dimension
        this.editRowItems.capacity = this.items[index].capacity
        this.editRowItems.metric_weight = this.items[index].metric_weight
        this.editRowItems.cigarette_count = this.items[index].cigarette_count
        this.editRowItems.deck_size = this.items[index].deck_size
        this.editRowItems.castor_type = this.items[index].castor_type
        this.editRowItems.overall_dimension = this.items[index].overall_dimension
        this.editRowItems.size = this.items[index].size
        this.editRowItems.top = this.items[index].top
        this.editRowItems.cross_weight = this.items[index].cross_weight
        this.editRowItems.quantity_case_pack_size = this.items[index].quantity_case_pack_size
        this.editRowItems.metric_ship = this.items[index].metric_ship
        this.editRowItems.head_band_size = this.items[index].head_band_size
        this.editRowItems.case_weight = this.items[index].case_weight
        this.updateRowModal = true
        this.editIndex = index
      },

      deleteRow(index) {
        this.items[index].status = '0'
        // this.items.splice(index, 1)
        // for (let x = 0; x < array.length; x++) {
        //   const element = array[x];
        // }
      },

      updateRowData() {
        this.items.splice(this.editIndex, 1)
        var newRowData = {}
        var colorArr = []
        console.log(this.editRowItems)
        newRowData.no = this.editRowItems.no
        newRowData.description = this.editRowItems.description
        newRowData.metric_description = this.editRowItems.metric_description
        newRowData.metric_capacity = this.editRowItems.metric_capacity
        newRowData.load_capacity = this.editRowItems.load_capacity
        newRowData.pack = this.editRowItems.pack
        newRowData.type_id = this.editRowItems.type_id
        newRowData.colors = this.editRowItems.colors
        newRowData.status = '1'
        newRowData.id = this.editRowItems.id
        for (let x = 0; x < this.tableTypeList.length; x++) {
          if (this.editRowItems.type_id === this.tableTypeList[x].id) {
            newRowData.type = this.tableTypeList[x].name
          }
        }
        for (let x = 0; x < this.colourList.length; x++) {
          for (let y = 0; y < newRowData.colors.length; y++) {
            if (newRowData.colors[y] === this.colourList[x].id) {
              colorArr.push(this.colourList[x].name)
            }
          }
        }
        newRowData.colour = colorArr.toString()
        newRowData.metric_dimension = this.editRowItems.metric_dimension
        newRowData.dimension = this.editRowItems.dimension
        newRowData.capacity = this.editRowItems.capacity
        newRowData.metric_weight = this.editRowItems.metric_weight
        newRowData.cigarette_count = this.editRowItems.cigarette_count
        newRowData.deck_size = this.editRowItems.deck_size
        newRowData.castor_type = this.editRowItems.castor_type
        newRowData.overall_dimension = this.editRowItems.overall_dimension
        newRowData.size = this.editRowItems.size
        newRowData.top = this.editRowItems.top
        newRowData.cross_weight = this.editRowItems.cross_weight
        newRowData.quantity_case_pack_size = this.editRowItems.quantity_case_pack_size
        newRowData.metric_ship = this.editRowItems.metric_ship
        newRowData.head_band_size = this.editRowItems.head_band_size
        newRowData.case_weight = this.editRowItems.case_weight
        this.items.splice(this.editIndex, 0, newRowData)
        this.updateRowModal = false
      },

      addNewRecord(data, type = null) {
        this.newModalLoading = true
        var ref = this
        api.request('post', '/admin/productcatalog/create', data)
        .then(response => {
          console.log(response)
          if (response.status === 200) {
            this.form = response.data
            this.newModalLoading = false

            if (response.data.error) {
              $.each(response.data.error, function (key, valueObj) {
                if (ref.newFormBackendValidation.hasOwnProperty(key.toString())) {
                  ref.newFormBackendValidation[key.toString()].isError = true
                  ref.newFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                  $('#' + key.toString()).parent().addClass('md-invalid')
                }
              })
            } else if (response.data.status === 'success') {
              if (type === 'stay') {
                this.dataTable.ajax.reload(null, false)
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else {
                ref.newModal = false
                this.dataTable.ajax.reload(null, false)
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
                this.clearNewForm()
              }
            }
          } else {
            this.editModalLoading = false
            // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: 'Something wrong'})
          }
        })
      },

      editNewRecord(data) {
        this.editModalLoading = true
        var ref = this
        api.request('post', '/admin/productcatalog/update/' + this.editItem, data)
          .then(response => {
            if (response.status === 200) {
              this.form = response.data
              this.editModalLoading = false
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.editFormBackendValidation.hasOwnProperty(key.toString())) {
                    ref.editFormBackendValidation[key.toString()].isError = true
                    ref.editFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                  }
                })
              } else if (response.data.status === 'success') {
                ref.editModal = false
                this.dataTable.ajax.reload(null, false)
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
                this.clearNewForm()
              }
            } else {
              this.editModalLoading = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            this.editModalLoading = false
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      },

      deleteNewRecord(id) {
        // eslint-disable-next-line no-undef
        Swal.fire({
          title: 'Are you sure?',
          text: 'If you delete this item, any products that are mapped will be deleted. Are you sure you want to proceed?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            api.request('get', '/admin/productcatalog/delete/' + id)
              .then(response => {
                if (response.status === 200 || response.data.status === 'success') {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: 'Record successfully deleted'})
                  this.dataTable.ajax.reload(null, false)
                }
              }).catch(error => {
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
              })
          }
        })
      },

      showEditModal(id) {
        this.clearNewForm()
        this.editItem = id
        api.request('get', '/admin/productcatalog/show/' + id)
          .then(response => {
            if (response.status === 200) {
              this.editForm.name = response.data.data.name
              this.editForm.category_catalog_id = response.data.data.category.id
              this.editForm.description = response.data.data.description
              this.descriptionArea = response.data.data.description
              var attributes = response.data.data.attributes
              for (let x = 0; x < attributes.length; x++) {
                for (let y = 0; y < this.headerList.length; y++) {
                  if (attributes[x].id === this.headerList[y].id) {
                    this.editForm.attributes.push(this.headerList[y].id)
                    this.tableHeadersSelected.push(this.headerList[y])
                  }
                }
              }
              this.changeTable()
              this.loadTableRow(response.data.data.items)
              this.uploadedImageList = response.data.data.images
              var x = 0
              this.uploadedImageList.forEach(image => {
                this.editForm.images.push(image.thumbnail)
                if (image.thumbnail === response.data.data.thumbnail_medium) {
                  this.editForm.selectedPrimary = x
                }
                x++
              })
              this.Imagelenght = []
              for (let x = 0; x < this.uploadedImageList.length; x++) {
                this.Imagelenght.push(x)
              }
              this.editModal = true
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },

      uploadIamgesS3(type) {
        // var ref = this
        for (let x = 0; x < this.fileList.length; x++) {
          let file = this.fileList[x].blob
          var randomMathName = Math.random()
          var thumbnail = 'products/' + randomMathName + '.jpg'
          if (type === 'new') {
            this.newForm.images.push('https://smartapprcp.s3.ap-southeast-1.amazonaws.com/' + thumbnail)
          } else {
            this.editForm.images.push('https://smartapprcp.s3.ap-southeast-1.amazonaws.com/' + thumbnail)
          }
          var params = {
            Key: thumbnail,
            ContentType: file.type,
            Body: file,
            ACL: 'public-read'
          }
          bucket.putObject(params, function (err, data) {
            if (err) {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: err})
            } else {
              console.log('Done')
            }
          })
        }
      },

      getValidationClassNewForm(fieldName) {
        const field = this.$v.newForm[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      getValidationClassEditForm(fieldName) {
        const field = this.$v.editForm[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      validateSubmission(type = null) {
        this.$v.$touch()
        if (!this.$v.newForm.$invalid && this.newModal) {
          this.newForm.description = this.descriptionArea
          this.newForm.items = this.items
          this.uploadIamgesS3('new')
          this.newForm.thumbnail_medium = this.newForm.images[this.newForm.selectedPrimary]
          console.log(this.newForm)
          this.addNewRecord(this.$v.newForm.$model, type)
        }
        if (!this.$v.editForm.$invalid && this.editModal) {
          this.editForm.description = this.descriptionArea
          this.editForm.items = this.items
          this.uploadIamgesS3('edit')
          this.editForm.thumbnail_medium = this.editForm.images[this.editForm.selectedPrimary]
          this.editNewRecord(this.$v.editForm.$model)
        }
      },
      getHeaderList() {
        api
          .request('get', '/admin/attributes/select')
          .then(response => {
            this.headerList = response.data.data
          })
      },
      getCategoryList() {
        api
          .request('get', '/admin/catalog_category/select')
          .then(response => {
            this.categoryList = response.data.data
          })
      },
      getTableTypeList() {
        api
          .request('get', '/admin/types/select')
          .then(response => {
            this.tableTypeList = response.data.data
          })
      },
      getColourList() {
        api
          .request('get', '/admin/colors/select')
          .then(response => {
            this.colourList = response.data.data
          })
      }

    }
  }
</script>

<style>

  @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_desc:after {
    font-family: 'FontAwesome';
  }

  table.dataTable thead .sorting:after {
    content: '\f0dc';
  }

  table.dataTable thead .sorting_asc:after {
    content: '\f0dd';
  }

  table.dataTable thead .sorting_desc:after {
    content: '\f0de';
  }


</style>



// WEBPACK FOOTER //
// ProductCatalogProduct.vue?99b09898